export const PRINT_SCORE = "app/Print/PRINT_SCORE";
export const PRINT_SCORE_SUCCESS = "app/Print/PRINT_SCORE_SUCCESS";
export const PRINT_SCORE_FAILURE = "app/Print/PRINT_SCORE_FAILURE";

export const PRINT_REVIEW = "app/Print/PRINT_REVIEW";
export const PRINT_REVIEW_SUCCESS = "app/Print/PRINT_REVIEW_SUCCESS";
export const PRINT_REVIEW_FAILURE = "app/Print/PRINT_REVIEW_FAILURE";

export const PRINT_BADGE = "app/Print/PRINT_BADGE";
export const PRINT_BADGE_SUCCESS = "app/Print/PRINT_BADGE_SUCCESS";
export const PRINT_BADGE_FAILURE = "app/Print/PRINT_BADGE_FAILURE";
